import { render, staticRenderFns } from "./companyTool.vue?vue&type=template&id=12dd7e39&scoped=true"
import script from "./companyTool.vue?vue&type=script&lang=js"
export * from "./companyTool.vue?vue&type=script&lang=js"
import style0 from "./companyTool.vue?vue&type=style&index=0&id=12dd7e39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dd7e39",
  null
  
)

export default component.exports